import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';
import { UserDtoSchema } from '../contracts';

const LoginRequestDtoSchema = z.object({
  email: z.email(),
  password: z.string(),
});

const LoginResponseDtoSchema = z.object({
  accessToken: z.string(),
  user: UserDtoSchema,
});

export type LoginRequestDto = z.infer<typeof LoginRequestDtoSchema>;
export type LoginResponseDto = z.infer<typeof LoginResponseDtoSchema>;

export const login = (
  dto: LoginRequestDto,
  config?: AxiosRequestConfig<LoginRequestDto>
) => {
  const data = LoginRequestDtoSchema.parse(dto);
  return api
    .post('/auth/login', data, config)
    .then(responseContract(LoginResponseDtoSchema));
};
